import { SHOW_SUPPLEMENTAL_MEDIA_VIEW } from '../supplementalMediaActions'
import { trackEvent } from 'aria-viewer/core/middleware/analyticsMiddleware'
import * as EVENTS from 'aria-viewer/analytics/constants/desktopAnalytics'
import { getTourData } from 'aria-viewer/analytics/utils/analyticUtils'

const supplementalMediaViewAnalytics = {
    [SHOW_SUPPLEMENTAL_MEDIA_VIEW]: (getState, action) => {
        const { stopIndex, stopid, inst_name, loc_name, owner_id, loc_id, userkey } = getTourData()(getState)

        return trackEvent(EVENTS.EXP_SUPP_MEDIA_CLICKED, {
            Stop_id: stopid,
            Stop_order: stopIndex,
            Institution: inst_name,
            Location: loc_name,
            Inst_ID: owner_id,
            Loc_ID: loc_id,
            Userkey: userkey,
        })
    },
}

export default supplementalMediaViewAnalytics
